import { useDictionary } from 'src/hooks/useDictionary';
import { MultiListResultState } from 'src/hooks/useSearchPage/searchListState/types';

import ResultsSummary from 'components/BaseHelpers/ResultsSummary';

import { SiteSearchListKey, SiteSearchResultItem, SiteSearchSortValue } from '../../useSiteSearch';

export type SiteSearchResultsSummaryProps = {
  activeKey: SiteSearchListKey | null;
  lists: Record<SiteSearchListKey, MultiListResultState<SiteSearchResultItem, SiteSearchSortValue>>;
  labels: Record<SiteSearchListKey, string>;
  listKeys?: SiteSearchListKey[];
  onSelectTab: (key: SiteSearchListKey) => void;
  onSelectOverview?: () => void;
};

const SiteSearchResultsSummary = (props: SiteSearchResultsSummaryProps): JSX.Element => {
  const { searchResultsReturnedLabel, allResultsLabel } = useDictionary();
  const {
    activeKey,
    listKeys = siteSearchSummaryListKeys,
    lists,
    labels,
    onSelectOverview,
    onSelectTab,
  } = props;
  const totalResultsCount = Object.values(lists).reduce(
    (acc, list) => acc + (list.totalCount ?? 0),
    0
  );

  const options = [
    ...(onSelectOverview
      ? [
          {
            label: `${allResultsLabel} (${totalResultsCount})`,
            onClick: onSelectOverview,
            disabled: false,
            selected: activeKey === null,
          },
        ]
      : []),
    ...listKeys.map((key) => ({
      label: `${labels[key]} (${lists[key].totalCount ?? 0})`,
      onClick: () => onSelectTab(key),
      disabled: (lists[key].totalCount ?? 0) === 0,
      selected: activeKey === null ? (lists[key].totalCount ?? 0) > 0 : activeKey === key,
    })),
  ];

  return <ResultsSummary header={searchResultsReturnedLabel} options={options} />;
};

const siteSearchSummaryListKeys: SiteSearchListKey[] = [
  'people',
  'services',
  'newsinsights',
  'resources',
];

export default SiteSearchResultsSummary;
